export class OnboardEmpAddressDetail{
  Id: number;
  EmpID: number;
  AddressLine1: string;
  AddressLine2: string;
  City: string;
  PinCode: number;
  District: string;
  State: string;
  Country: string;
  IsAddressSame: boolean;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  
}
